<template>
  <v-app class="">
    <v-main class="auth-pages">
      <div class="header-auth position-relative border-radius-xl min-vh-100">
        <v-container class="py-0">
          <v-row>
            <v-col lg="4" md="7" class="d-flex flex-column mx-lg-0 mx-auto">
              <fade-transition
                :duration="200"
                origin="center top"
                mode="out-in"
              >
                <!-- your content here -->
                <router-view></router-view>
              </fade-transition>
            </v-col>
            <v-col
              cols="6"
              class="
                d-lg-flex d-none
                h-100
                my-auto
                pe-0
                pt-0
                position-absolute
                top-0
                end-0
                text-center
                justify-center
                flex-column
              "
            >
              <div
              style="max-height: 88%;"
                class="
                  position-relative
                  bg-gradient-primary
                  h-100
                  ma-4
                  px-16
                  border-radius-lg
                  d-flex
                  flex-column
                  justify-center
                "
              >
                <v-img
                  src="../../assets/login-background.png"
                  alt="pattern-lines"
                  class="position-absolute opacity-4 start-0 h-100 w-100"
                  style="border-radius: 15px;"
                >
                </v-img>
                <div class="position-relative">
           
                  
                </div>
                <h4 class="text-h4 mt-10 text-white font-weight-bolder mb-2">
                  Conditional-Based Monitoring
                </h4>
                <p class="text-white">
                  Go beyond traditional vibration analysis for revolutionary monitoring solutions.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  name: "page-layout",
  components: {
    FadeTransition,
  },
  data() {
    return {};
  },
};
</script>
<style>
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Maintains aspect ratio */
  pointer-events: none; /* Prevents user interaction */
}
</style>